import { Validation } from 'ts/interfaces/Validation';
import i18n from '../utils/i18n';
export const googleMapsKey = 'AIzaSyBxEwtMRXpcXdcMScNSUAF6G6sr9wwf3cA';
const { protocol, hostname } = window.location;

export const loginHubUrl = 'https://b2blogin.beprotravel.com';
export const cdnUrl = process.env.REACT_APP_DEBUG
  ? // ? 'http://25flyeast.beprotravel.com/'
    'https://25issta.beprotravel.com'
  : `${protocol}//${hostname}`;
export const baseUrl = cdnUrl + '/backend';
export const blobUrl = cdnUrl + '/backend/s3/prod.beprotravel/cdn/';
export const maxInactiveMinutes = 120;

export const b2b = true;
export const b2c = false;
export const displaySecretBook = false;
export const needToScreenshot = true;
export const showPaymentLoader = true;
export const isMultiFlight = true;
export const isNetravel = false;
export const isTT = false;
export const isFreeCxlDefault = false;

export const defaultLoaderUrl = '/backend/s3/prod.beprotravel/cdn/frontend/bepro.gif';
export const colorContrast = '#191e3b';
export const colorBorder = '#ddd';
export const colorDark = '#666';
export const colorStar = '#ffb700';
export const colorSuccess = '#4caf50';
export const colorDanger = '#f44336';
export const mapSupplier = 'osm' as 'google' | 'osm';
export const defaultSearchTypeId = 0;

export const sexOptions = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
];

export const getGender = () => {
  return [
    { value: 'Male', label: i18n.t('male') },
    { value: 'Female', label: i18n.t('female') },
  ];
};

export const credentialsValidation: Validation = {
  username: { required: true },
  password: { required: true },
};

export const imgsCar = [
  require('../assets/img/vehicles/Private-Car-Regular.png'),
  require('../assets/img/vehicles/Private-Car-Luxury.png'),
  require('../assets/img/vehicles/Minivan-Shuttle.png'),
  require('../assets/img/vehicles/Minibus.png'),
  require('../assets/img/vehicles/Bus.png'),
  require('../assets/img/vehicles/Private-Car-Business.png'),
  require('../assets/img/vehicles/Minivan-Regular.png'),
  require('../assets/img/vehicles/Handicap.png'),
  require('../assets/img/vehicles/Private-Driver.png'),
  require('../assets/img/vehicles/Private-Car-Regular.png'),
  require('../assets/img/vehicles/Limousine.png'),
];

export const hotelConfigImage = {
  ci: require('../assets/img/hotel-config/cl_i.png'),
  p1i: require('../assets/img/hotel-config/p1_i.png'),
  p2i: require('../assets/img/hotel-config/p2_i.png'),
  bi: require('../assets/img/hotel-config/b_i.png'),
  pri: require('../assets/img/hotel-config/p_i.png'),
  n1: require('../assets/img/hotel-config/n1.png'),
  n2: require('../assets/img/hotel-config/n2.png'),
  n3: require('../assets/img/hotel-config/n3.png'),
  n4: require('../assets/img/hotel-config/n4.png'),
  n5: require('../assets/img/hotel-config/n5.png'),
  n6: require('../assets/img/hotel-config/n6.png'),
  n7: require('../assets/img/hotel-config/n7.png'),
  n8: require('../assets/img/hotel-config/n8.png'),
};

export const imgUs = require('../assets/img/us.png');
export const imgIs = require('../assets/img/is.png');
export const imgBg = require('../assets/img/skies.jpg');
export const imgBgImg = imgBg;
export const imgLogo = require('../assets/img/logo.png');
export const fl1Img = require('../assets/img/fl1.png');
export const fl2Img = require('../assets/img/fl2.png');
export const gIco = require('../assets/img/g_ico.png');
export const trIco = require('../assets/img/tr_ico.png');
export const mo1Img = require('../assets/img/v_1.png');
export const mo2Img = require('../assets/img/v_2.png');
export const imgLoaderMain = require('../assets/img/loader.gif');
export const imgPaymentLoader = require('../assets/img/loader.gif');
export const imgWaypointA = require('../assets/img/waypoint-a.png');
export const imgWaypointB = require('../assets/img/waypoint-b.png');
export const imgBluePoint = require('../assets/img/blue.png');
export const imgRedPoint = require('../assets/img/red.png');
export const imgCenterPoint = require('../assets/img/center.png');
export const imgTripAdvisor = require('../assets/img/tripadvisor.png');
export const imgDefaultBg = require('../assets/img/newbg.jpg');
export const imgGlobe = require('../assets/img/globe.png');
export const comodoImg = require('../assets/img/comodo.png');
export const images = {
  logo108: require('../assets/img/flyeast-logo.png'),
  elephant: require('../assets/img/tb2-testimonials-decor.png'),
};

export const uiConfig = { colorBorder, colorContrast, colorStar };

export const hotelConfig = {
  cdnUrl,
};

export const flightConfig = {
  ...uiConfig,
  blobUrl,
  cdnUrl,
};

export const availableLanguages = [
  { lang: 'en', country: 'us', name: 'English' },
  { lang: 'es', country: 'es', name: 'Español' },
  { lang: 'it', country: 'it', name: 'Italiano' },
  { lang: 'fr', country: 'fr', name: 'Français' },
];

export const defaultUserSiteConfig = {
  base: {
    openDetailsInNewTab: false,
    rememberModeEnabled: true,
    theme: 'classic',
  },
  hotel: {
    areRoomsGrouped: false,
    areRoomsColoured: false,
    isRoomNameCleared: true,
    areRoomsFiltered: false,
    isCubeDesign: true,
    showRoomsInTab: false,
    isShortMode: true,
    isCubeDesignByEat: false,
    displayMode: 7,
    roomMode: 0,
    oneHotelSearchByOneSupplier: false,
  },
};

export const defaultHotelBookS3 = {
  docket: {
    display: '1',
    mandatory: '0',
  },
  tourSubject: {
    display: '1',
    mandatory: '0',
  },
  passportNumber: {
    display: '0',
    mandatory: '0',
  },
  passportValidTill: {
    display: '0',
    mandatory: '0',
  },
  phone: {
    display: '2',
    mandatory: '2',
  },
  email: {
    display: '2',
    mandatory: '2',
  },
};

export const packageConfig = {
  blobUrl,
  cdnUrl,
  showOrderCompanyId: true,
};

export enum SearchBoxTabs {
  flight = 'FLT',
  package = 'PAC',
  tours = 'TOR',
  hotel = 'HTL',
  transfer = 'TRA',
  dynamicFHS = 'FHS',
  dynamicFH = 'FLH',
  hot2 = 'HTL2',
}
